import { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useWalletModal } from '../../context/WalletModalContext';
import BreathingBlocks from '../Hero/BreathingBlocks';
import './Header.css';

const NAV_LINKS = [
  { label: 'Protocol', href: '#protocol' },
  { label: 'Ecosystem', href: '#ecosystem' },
  { label: 'Get started', href: '#cta' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { open: openWalletModal } = useWalletModal();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Lock body scroll while the mobile drawer is open
  useEffect(() => {
    document.body.style.overflow = drawerOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [drawerOpen]);

  const handleNavClick = () => setDrawerOpen(false);

  return (
    <header className={`site-header ${scrolled ? 'is-scrolled' : ''}`}>
      <BreathingBlocks className="site-header__blocks" />
      <div className="container site-header__inner">
        <a href="#top" className="site-header__logo">
          <img src="/logo-mark.svg" className="site-header__logo-mark" alt="" aria-hidden="true" />
          COTI
        </a>

        <nav className="site-header__nav" aria-label="Primary">
          {NAV_LINKS.map((link) => (
            <a key={link.href} href={link.href}>
              {link.label}
            </a>
          ))}
        </nav>

        <div className="site-header__actions">
          <button type="button" className="btn btn--solid" onClick={openWalletModal}>
            Connect wallet
          </button>
        </div>

        <button
          type="button"
          className={`site-header__burger ${drawerOpen ? 'is-open' : ''}`}
          aria-label={drawerOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={drawerOpen}
          onClick={() => setDrawerOpen((o) => !o)}
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      <AnimatePresence>
        {drawerOpen && (
          <motion.div
            className="site-header__drawer"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.28, ease: [0.22, 1, 0.36, 1] }}
          >
            <nav className="site-header__drawer-nav" aria-label="Mobile">
              {NAV_LINKS.map((link) => (
                <a key={link.href} href={link.href} onClick={handleNavClick}>
                  {link.label}
                </a>
              ))}
              <button
                type="button"
                className="btn btn--solid"
                onClick={() => {
                  handleNavClick();
                  openWalletModal();
                }}
              >
                Connect wallet
              </button>
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}